import type { TermsContent } from "./types";

export const termsZh: TermsContent = {
  locale: "zh",
  seo: {
    title: "用户协议 - Prismark",
    description: "Prismark 用户协议，说明产品使用规则、用户内容、权限、免责声明及联系方式。"
  },
  title: "用户协议",
  updated: "最后更新：2026 年 9 月 13 日",
  intro: [
    "欢迎使用 Prismark。请在使用 Prismark 前仔细阅读本用户协议。你下载、安装、访问或使用 Prismark，即表示你已阅读、理解并同意受本协议约束。",
    "如果你不同意本协议中的任何内容，请停止使用 Prismark。"
  ],
  sections: [
    {
      title: "1. 关于 Prismark",
      body: [
        "Prismark 是一款面向 iOS 的轻量而专业的相机应用，用于拍照、视频录制、双摄录制、相册回看以及相关拍摄辅助功能。",
        "Prismark 旨在提供轻量而专业的拍摄体验。部分功能可能会受到设备型号、iOS 版本、系统权限、硬件能力或地区设置的影响。"
      ]
    },
    {
      title: "2. 使用规则",
      body: ["你应以合法、合理、尊重他人权益的方式使用 Prismark。", "你不得使用 Prismark 从事以下行为："],
      bullets: [
        "侵犯他人隐私、肖像权、名誉权、知识产权或其他合法权益；",
        "在未获得必要授权或同意的情况下拍摄、录制或传播他人影像、声音或相关内容；",
        "用于偷拍、骚扰、跟踪、恐吓、欺诈或其他违法、侵权、不当用途；",
        "干扰、破坏或试图绕过 Prismark 的正常功能、安全机制或技术限制；",
        "违反适用法律法规、平台规则或 App Store 相关规定的行为。"
      ]
    },
    {
      title: "3. 用户内容",
      body: [
        "你通过 Prismark 拍摄、录制、保存或管理的照片、视频及其他内容，归你或相关权利人所有。",
        "Prismark 不主张拥有你通过本应用创建的照片、视频或其他用户内容的所有权。",
        "你理解并同意，你应对自己拍摄、保存、分享、发布或以其他方式使用相关内容的行为承担责任。你应确保相关内容的获取、使用和传播不侵犯任何第三方权益，也不违反适用法律法规。"
      ]
    },
    {
      title: "4. 权限与设备访问",
      body: ["为了提供核心功能，Prismark 可能会请求访问你的相机、麦克风、照片图库或其他必要的系统权限。", "这些权限主要用于："],
      bullets: [
        "使用相机进行拍照或视频录制；",
        "使用麦克风录制视频声音；",
        "保存照片或视频到系统相册；",
        "从相册中查看、选择或管理相关媒体内容。"
      ]
    },
    {
      title: "5. 功能可用性",
      body: [
        "Prismark 会尽力保持功能稳定、体验流畅，但我们不保证所有功能在所有设备、系统版本或使用环境下都始终可用。",
        "部分功能，尤其是双摄录制、HDR 视频、特定拍摄辅助能力或与系统硬件相关的功能，可能会受到设备型号、iOS 版本、系统权限、硬件能力或系统限制的影响。",
        "我们可能会根据产品规划、技术限制、系统变化或运营需要，对 Prismark 的功能、界面、内容或服务进行更新、调整、暂停或终止。"
      ]
    },
    {
      title: "6. 付费功能",
      body: [
        "Prismark 不需要账号和登录。核心相机功能均已包含在内，不额外收费：拍照与录像、手动曝光参数、内置滤镜、照片水印，以及各项拍摄辅助工具。",
        "其中三项功能属于 Prismark Pro：导入你自己的 LUT、ProRAW 与 RAW 输出、双摄画中画录制。Prismark Pro 是一次性应用内购买，并非订阅，没有周期扣款，不会自动续订，也不需要取消。应用本身与 Prismark Pro 的当前价格及可用范围，均以 App Store 商品页和应用内购买前的展示为准。",
        "Prismark Pro 与购买时使用的 Apple 账户绑定。在你的其他设备上，或重新安装之后，可以用应用内的「恢复购买」取回。如果你在 Prismark 提供付费档位之前就已下载过本应用，这些功能对你仍然免费。",
        "你应在购买前仔细阅读相关说明。所有购买和退款通常由 App Store 及 Apple 相关规则处理。"
      ]
    },
    {
      title: "7. 第三方服务",
      body: [
        "Prismark 可能会在必要时使用 iOS 系统能力、App Store 服务、系统相册、系统分享功能或其他第三方服务。",
        "第三方服务可能会受到其各自条款和隐私政策约束。我们无法控制第三方服务的内容、规则或可用性，也不对第三方服务导致的问题承担责任。"
      ]
    },
    {
      title: "8. 知识产权",
      body: [
        "Prismark 的名称、图标、界面设计、视觉元素、软件代码、文案、页面内容及相关品牌资产，均受适用的知识产权法律保护。",
        "未经我们事先书面许可，你不得复制、修改、分发、出售、出租、反向工程、反编译、试图提取源代码，或以其他未经授权的方式使用 Prismark 的任何部分。",
        "本协议并未向你转让 Prismark 或相关内容的任何所有权。你仅获得在遵守本协议前提下使用 Prismark 的有限、非独占、不可转让许可。"
      ]
    },
    {
      title: "9. 免责声明",
      body: [
        "Prismark 按“现状”和“可用”状态提供。我们会努力提供稳定、可靠的产品体验，但不保证 Prismark 完全无错误、不中断、始终安全，或一定满足你的全部需求。",
        "你理解并同意，使用 Prismark 进行拍摄、录制、保存或分享内容时，应自行判断拍摄环境、设备状态、内容合法性和使用风险。",
        "对于因设备故障、系统限制、权限设置、用户误操作、第三方服务、网络环境或其他不可控因素导致的内容丢失、拍摄失败、功能不可用或其他损失，我们在适用法律允许的范围内不承担责任。"
      ]
    },
    {
      title: "10. 责任限制",
      body: [
        "在适用法律允许的最大范围内，Prismark 及其开发者、运营者不对任何间接、偶然、特殊、惩罚性或后果性损失承担责任，包括但不限于数据丢失、内容损坏、利润损失、业务中断或因使用或无法使用 Prismark 而产生的损失。",
        "如果适用法律不允许完全排除或限制某些责任，本条款将在法律允许的最大范围内适用。"
      ]
    },
    {
      title: "11. 协议变更",
      body: [
        "我们可能会不时更新本用户协议。更新后的协议将发布在 Prismark 官网或应用相关页面中，并标明更新日期。",
        "如果你在协议更新后继续使用 Prismark，即表示你接受更新后的协议。若你不同意更新内容，请停止使用 Prismark。"
      ]
    },
    {
      title: "12. 终止",
      body: [
        "如果你违反本协议，或以违法、不当、侵权方式使用 Prismark，我们有权在适用法律允许的范围内限制、暂停或终止你对 Prismark 的使用。",
        "你也可以随时停止使用 Prismark，并从设备中删除应用。"
      ]
    },
    {
      title: "13. 联系我们",
      body: ["如果你对本用户协议有任何问题、意见或请求，可以通过以下方式联系我们：", "Email：axqora@gmail.com"]
    }
  ],
  privacyLink: {
    body: "关于 Prismark 如何使用权限和处理数据，请阅读我们的隐私政策。",
    label: "隐私政策",
    href: "/zh/privacy"
  }
};
